<template>
  <!-- eslint-disable max-len -->
  <div>
    <p>
      Boson Group Inc. («<strong>{{ APP_NAME }}</strong>)» provides this Privacy
      Policy to let you know our policies and procedures regarding the
      collection, use and disclosure of information through
      https://{{ HOME_DOMAIN }}/ (the «<strong>Website</strong>»).
      {{ APP_NAME }} provides a platform enabling job candidates («Candidates»)
      and employers («Employers») to engage in a live interview, and evaluation
      activities.
    </p>
    <p>
      The {{ APP_NAME }} service is a professional website directed toward job
      seekers, employers and staffing organizations. As such, an individual must
      be aged sixteen (16) or over to create an account through our website. As
      such, the website is not directed toward children or minors.
    </p>
    <ol>
      <li>
        <p>
          <strong>What data do we collect?</strong>
        </p>
        <p>
          {{ APP_NAME }} collects the following data:
        </p>
        <ul>
          <li>
            <p>
              Personal identification information: may include, but not be
              limited to, your name, your address, email address, phone number,
              etc.
            </p>
          </li>
          <li>
            <p>
              The information we may collect automatically from your device. In
              some countries, including countries in the European Economic Area
              and the UK, this information may be considered personal information
              under applicable data protection laws. Specifically, this
              information may include IP addresses, other unique device IDs or
              addresses, web browser and/or device type, the pages you view on
              the Services and the dates and times you visit, access or use the
              Service.
            </p>
          </li>
          <li>
            <p>
              Some of this information may be collected using cookies and similar
              tracking technology, as explained further under the heading
              «Cookies policy» below.
            </p>
          </li>
          <li>
            <p>
              Information that we obtain from third party sources. From time to
              time, we may receive personal information about you from third
              party sources, but only where we have checked that these third
              parties either have your consent or are otherwise legally permitted
              or required to disclose your personal information to us.
            </p>
          </li>
        </ul>
      </li>
      <li>
        <p>
          <strong>
            What information do we collect through the Services?
          </strong>
        </p>
        <p>
          If you are a job candidate («Candidate») or employee («Employee») using our
          Services on behalf of one of our customers who are engaging us to provide
          the Services to them (the «Potential Employers»), we are collecting and
          processing your personal information on behalf of the Potential Employers.
          In such cases, we are acting as a data processor and are collecting and
          processing your personal information on their behalf and in accordance with
          their instructions.
        </p>
        <p>
          Candidates may complete a job interview through the Services which can
          include information such as work history, skills, experience, abilities,
          work style and other responses to questions, as well as submissions through
          a variety of types of media including video/audio interviews, coding
          challenges, training exercises and the like.
        </p>
      </li>
      <li>
        <p>
          <strong>How do we collect your data?</strong>
        </p>
        <p>
          You directly provide {{ APP_NAME }} with most of the data we collect. We
          collect data and process data when you: 1) use our products or services, 2)
          use or view our website via your browser’s cookies.
        </p>
      </li>
      <li>
        <p>
          <strong>The reasons, the legal basis </strong>
          <strong>and the retention period</strong>
        </p>
        <p>
          Where it is necessary to obtain your prior consent to the processing
          concerned in order for us to be allowed to do it, we will obtain and rely
          on your consent in relation to the processing concerned. Otherwise, we will
          process your personal data only where the processing is necessary:
        </p>
        <ul>
          <li>
            <p>
              for the performance of a contract to which you are a party or in
              order to take steps at your request prior to entering into such a
              contract; for compliance with a legal obligation to which we are a
              subject; or
            </p>
          </li>
          <li>
            <p>
              for the purposes of the legitimate interests pursued by us or
              another person, provided that this will only be in circumstances in
              which those legitimate interests are not overridden by your
              interests or fundamental rights and freedoms which require
              protection of personal data (most circumstances in which we process
              your personal data in relation to a relationship that we have with
              the person that you work for will fall into this category)
            </p>
          </li>
        </ul>
        <p>
          Where {{ APP_NAME }} obtains information about a consumer from its customers
          or other third parties, {{ APP_NAME }} presumes that the consumer has
          previously provided appropriate consent to the party from whom
          {{ APP_NAME }} obtains the information. {{ APP_NAME }} will keep your
          personal data for 12 month.
        </p>
      </li>
      <li>
        <p>
          <strong>How will we use your data?</strong>
        </p>
        <p>
          {{ APP_NAME }} collects your data so that we can:
        </p>
        <ul>
          <li>
            <p>
              operate, maintain, enhance, and provide all of the features and
              services found on {{ APP_NAME }} website;
            </p>
          </li>
          <li>
            <p>
              process your order and manage your account;
            </p>
          </li>
          <li>
            <p>
              email you with special offers on other products and services we
              think you might like;
            </p>
          </li>
          <li>
            <p>
              understand and analyze the usage trends, interests, and preferences
              of our users, to improve the way our platform works and looks, and
              to create new features and functionality;
            </p>
          </li>
          <li>
            <p>
              use «automatically collected» information and «cookies» information
              to: (a) personalize our services, such as remembering your
              information so that you will not have to re-enter it during your
              visit or the next time you visit our website; (b) monitor and
              analyze the effectiveness of application and evaluation activities;
              (c) monitor aggregate usage metrics such as total number of users,
              pages and media and features of the website accessed, etc.; and (d)
              track your entries, submissions, and status, including the ways in
              which you may interact with our service.
            </p>
          </li>
        </ul>
      </li>
      <li>
        <p>
          <strong>Who does {{ APP_NAME }} share my personal information with?</strong>
        </p>
        <p>
          We are not in the business of selling your personal information. We may,
          however, disclose your personal information to the following categories of
          recipients:
        </p>
        <ul>
          <li>
            <p>
              to the applicable Employer(s);
            </p>
          </li>
          <li>
            <p>
              {{ APP_NAME }} may make available certain automatically collected
              and other aggregate non-Personally-Identifiable Information to
              assist such parties in understanding our user's interests, habits,
              and usage patterns for certain programs, content, services,
              advertisements, promotions, and/or functionality available through
              {{ APP_NAME }} service, as well as to provide a variety of different
              candidate analytics, such as success metrics, uniqueness scores for
              submitted materials, and other statistical and analytical results
              derived from the information you may submit to the Service.
            </p>
          </li>
          <li>
            <p>
              to our group companies, third party services providers and partners
              who provide data processing services to us (for example, to support
              the delivery of, provide functionality on, or help to enhance the
              security and features of our Website and Services), or who
              otherwise process personal information for purposes that are
              described in this Privacy Policy or notified to you when we collect
              your personal information;
            </p>
          </li>
          <li>
            <p>
              to any competent law enforcement body, regulatory, government
              agency, court or other third party where we believe disclosure is
              necessary (1) as a matter of applicable law or regulation, (2) to
              exercise, establish or defend our legal rights, or (3) to protect
              your vital interests or those of any other person;
            </p>
          </li>
          <li>
            <p>
              in connection with any proposed purchase, reorganisation, merger or
              acquisition of any part of our business, provided that we inform
              the buyer it must use your personal information only for the
              purposes disclosed in this Privacy Policy.
            </p>
          </li>
        </ul>
      </li>
      <li>
        <p>
          <strong>Cookies Policy</strong>
        </p>
        <p>
          Our Cookies Policy is set out below:
        </p>
        <p>
          How do we use cookies?
        </p>
        <p>
          We may use «persistent cookies» to save your registration ID and login
          password for future logins to the Service. We may use «session ID cookies»
          to enable certain features of the Service, to better understand how you
          interact with the Service and to monitor aggregate usage and web traffic
          routing on the Service. You can instruct your browser, by changing its
          options, to stop accepting cookies or to prompt you before accepting a
          cookie from the websites you visit. If you do not accept cookies, however,
          you may not be able to use all aspects of the Application We also use
          cookies in our marketing emails (which you may receive if you have provided
          us with your consent to contact you in that way) to enable us to review how
          users interact with our marketing. This helps us to tailor it more
          appropriately and make it more user-friendly.
        </p>
        <p>
          What are cookies and how do they work?
        </p>
        <p>
          Cookies are text files placed on your computer to collect standard Internet
          log information and visitor behavior information. When you visit our
          websites, we may collect information from you automatically through cookies
          or similar technology For further information, visit allaboutcookies.org.
        </p>
        <p>
          What sort of cookies do we use?
        </p>
        <p>
          We use the following types of cookies: (1) Strictly necessary cookies.
          These are cookies that are required for the operation of our website and
          under our terms with you. (2) Analytical/performance cookies. They allow us
          to recognise and count the number of visitors and to see how visitors move
          around our website when they are using it. (3) Functionality cookies. These
          are used to recognise you when you return to our website. (4) Targeting
          cookies. These cookies record your visit to our website, the pages you have
          visited and the links you have followed. We may also share this information
          with third parties for this purpose.
        </p>
        <p>
          When do our cookies expire?
        </p>
        <p>
          Except for strictly necessary cookies, all cookies used on our site will
          expire after 31 days.
        </p>
      </li>
      <li>
        <p>
          <strong>Do Not Track (DNT)</strong>
        </p>
        <p>
          {{ APP_NAME }} takes privacy and security very seriously and strives to put
          our members first in all aspects of our business. With regard to DNT,
          {{ APP_NAME }} currently doesn't respond to DNT signals in browsers because
          no DNT standard has been adopted.
        </p>
      </li>
      <li>
        <p>
          <strong>Protection of personal data.</strong>
        </p>
        <p>
          We have taken appropriate technical and organizational security measures in
          order to protect your personal data against loss, misuse, alteration and/or
          destruction. Although we exercise reasonable care in providing secure
          transmission of information between your equipment and our systems, we
          cannot ensure or warrant the security of any information transmitted to us
          over the internet. Access to relevant personal data is only granted to
          those authorized employees who require access to the relevant personal data
          for performance of their work.
        </p>
        <p>
          If {{ APP_NAME }} learns of a security systems breach, then we may attempt
          to notify you electronically so that you can take appropriate protective
          steps. {{ APP_NAME }} may post a notice through its platform if a security
          breach occurs. Depending on where you live, you may have a legal right to
          receive notice of a security breach in writing. To receive a free written
          notice of a security breach you should notify us at {{ SUPPORT_EMAIL }}.
        </p>
      </li>
      <li>
        <p>
          <strong>Marketing</strong>
        </p>
        <p>
          {{ APP_NAME }} would like to send you information about products and
          services of ours that we think you might like. If you have agreed to
          receive marketing, you may always opt out at a later date. You have the
          right at any time to stop {{ APP_NAME }} from contacting you for marketing
          purposes. Withdrawing said consent is an easy task: you can click
          «Unsubscribe» underneath any newsletter-mail. When subscribing to the
          Harver newsletter, we will ask you the following information: e-mail
          address.
        </p>
      </li>
      <li>
        <p>
          <strong>What are your data protection rights?</strong>
        </p>
        <p>
          {{ APP_NAME }} would like to make sure you are fully aware of all of your
          data protection rights. Every user is entitled to the following:
        </p>
        <ul>
          <li>
            <p>
              <strong>The right to access</strong>
              – You have the right to request {{ APP_NAME }} for copies of your
              personal data.
            </p>
          </li>
          <li>
            <p>
              <strong>The right to rectification</strong>
              – You have the right to request that {{ APP_NAME }} correct any
              information you believe is inaccurate. You also have the right to
              request {{ APP_NAME }} to complete the information you believe is
              incomplete.
            </p>
          </li>
          <li>
            <p>
              <strong>The right to erasure</strong>
              – You have the right to request that {{ APP_NAME }} erase your
              personal data, under certain conditions.
            </p>
          </li>
          <li>
            <p>
              <strong>The right to restrict processing</strong>
              – You have the right to request that {{ APP_NAME }} restrict the
              processing of your personal data, under certain conditions.
            </p>
          </li>
          <li>
            <p>
              <strong>The right to object to processing</strong>
              – You have the right to object to {{ APP_NAME }} processing of your
              personal data, under certain conditions.
            </p>
          </li>
          <li>
            <p>
              <strong>The right to data portability</strong>
              – You have the right to request that {{ APP_NAME }} transfer the
              data that we have collected to another organization, or directly to
              you, under certain conditions.
            </p>
          </li>
        </ul>
        <p>
          If you have a complaint about any processing of your personal data being
          conducted by us, you can contact us or, if you are based in the EU or AUS
          you can contact your local regulator.
        </p>
        <p>
          If you make a request, we have one month to respond to you. If you would
          like to exercise any of these rights, please contact us at our email:
          {{ SUPPORT_EMAIL }}
        </p>
      </li>
      <li>
        <p>
          <strong>Privacy policies of other websites</strong>
        </p>
        <p>
          The Our Company website contains links to other websites. Our privacy
          policy applies only to our website, so if you click on a link to another
          website, you should read their privacy policy.
        </p>
      </li>
      <li>
        <p>
          <strong>Changes to our privacy policy</strong>
        </p>
        <p>
          Please revisit this page periodically to stay aware of any changes to this
          Privacy Policy, which may be revised periodically at {{ APP_NAME }}
          discretion. If we modify the Privacy Policy, we will make it available
          through our website, and indicate the date of the latest revision. In the
          event that the modifications materially alter your rights or obligations
          hereunder we will make reasonable efforts to notify you of the change. Our
          Company keeps its privacy policy under regular review and places any
          updates on this web page. This privacy policy was last updated on 01 January
          {{ new Date().getFullYear() }}.
        </p>
      </li>
      <li>
        <p>
          <strong>How to contact us</strong>
        </p>
        <p>
          To access your information, ask questions about our privacy practices, or
          issue a complaint, contact us at: <a :href="`https://${HOME_DOMAIN}`">{{ APP_NAME }}</a>
        </p>
        <p>
          ООО "Бозон".
        </p>
        <p>
          Address:<br>
          919 North Market Street<br>
          Suite 950<br>
          Wilmington<br>
          Delaware 19801<br>
          USA<br>
        </p>

        <p>
          Privacy Policy Inquiries: <a :href="`mailto:${SUPPORT_EMAIL}`">{{ this.SUPPORT_EMAIL }}</a>
        </p>
      </li>
    </ol>
  </div>
<!-- eslint-enable max-len -->
</template>

<script>
import { HOME_DOMAIN, APP_NAME, SUPPORT_EMAIL } from '@/helpers/constants';

export default {
  name: 'Confidential',
  data() {
    return {
      HOME_DOMAIN,
      APP_NAME,
      SUPPORT_EMAIL,
    };
  },
  metaInfo() {
    return {
      title: this.pageTitle,
    };
  },
  data() {
    return {
      pageTitle: 'Privacy Policy Huntica',
    };
  },
  mounted() {
    this.$nextTick(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  },
};
</script>

<style lang="scss" scoped>
  .privacy-head {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }
  ul li {
    list-style-type: disc;
  }
</style>
